import { useFetchWrapper } from './fetch-wrapper'

const useClinicService = () => {

    const fetchWrapper = useFetchWrapper()

    const GetBusinessUnit = async (locationUniqueId) => {
        let result = undefined
        try {
            result = await fetchWrapper.get(`clinic/${locationUniqueId}/businessunit`)
            console.log('clinic result', result)
        } catch (error) {
            return undefined
        }

        return result
    }

    const GetClinic = async (locationUniqueId) => {
        let result = undefined
        try {
            result = await fetchWrapper.get(`clinic/${locationUniqueId}`)
            console.log('clinic result', result)
        } catch (error) {
            return undefined
        }

        return result
    }

    const GetHoliday = async () => {
        try {
            const result = await fetchWrapper.get(`clinic/holidays`);
            console.log("Fetched Holiday:", result);  //  Log the exact response
            return result;
        } catch (error) {
            console.error("Error fetching holidays:", error);
            return [];
        }
    };

    const GetCPTGroup = async (idPrescriber) => {
        let result = undefined
        try {
            result = await fetchWrapper.get(`clinic/${idPrescriber}/cptgroups`)
            //console.log('clinic CPT result', result)
        } catch (error) {
            return undefined
        }

        return result
    }



    const GetOtherGroups = async (idPrescriber) => {
        let result = undefined
        try {
            result = await fetchWrapper.get(`clinic/${idPrescriber}/othercpt`)
            //console.log('clinic Other result', result)
        } catch (error) {
            return undefined
        }

        return result
    }

    const GetPrescriberValue = async (idPrescriber) => {
        let result = undefined
        try {
            result = await fetchWrapper.get(`clinic/${idPrescriber}/cptvalues`)
        } catch (error) {
            return undefined
        }

        return result
    }

    return { GetBusinessUnit, GetClinic, GetHoliday, GetCPTGroup, GetOtherGroups, GetPrescriberValue }
}

export { useClinicService };